import React, { useEffect, lazy, Suspense } from 'react'
import { NavLink, Route, Redirect, Switch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Card, Container } from 'reactstrap'

import { fetchCourseSettings } from 'store/ConfigurationSettings/CourseConfig/actions'
import { fetchOrgGroups } from 'store/OrgGroup/actions'
import { fetchCourses } from '../Course/actions'
import { fetchGroups, fetchRoles } from '../Group/actions'
import Loader from 'views/pages/Loader'

// Style css
import '../../views/pages/ManagerReport/styles/styles.css'

// Global Css Leon
import '../../assets/css/Global/style.css'
import ImportUser from 'views/pages/User/ImportUser'

const Stores = lazy(() => import('views/pages/Stores'))
const OrgGroup = lazy(() => import('views/pages/OrgGroup'))
const RoleGroup = lazy(() => import('views/pages/RoleGroup'))
const Location = lazy(() => import('views/pages/Location'))
const QuestionBank = lazy(() => import('views/pages/QuestionBank'))
const SettingsGroup = lazy(() => import('views/pages/Group/SettingsGroup'))
const UserList = lazy(() => import('views/pages/User/UserList'))
const UserForm = lazy(() => import('views/pages/User/UserForm'))
const Role = lazy(() => import('views/pages/Role'))
const ExternalReports = lazy(() => import('views/pages/ExternalReports'))
const Rewards = lazy(() => import('views/pages/Rewards'))
const Help = lazy(() => import('views/pages/Help'))
const SettingsContainer = (props) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchGroups())
    dispatch(fetchRoles())
    dispatch(fetchCourses())

    dispatch(fetchCourseSettings())
    dispatch(fetchOrgGroups())
  }, [dispatch])

  // const language = props.language || {}
  const user = useSelector((state) => state.auth.user)
  const langState = useSelector((state) => state.language)
  let language = {}
  langState.language //eslint-disable-line
    ? (language = langState.language.data)
    : null
  const groups = useSelector((state) => state.groups)
  const roleGroups = useSelector((state) => state.roleGroups)
  const roles = useSelector((state) => state.roles)

  const courseConfig = useSelector((state) => state.courseConfig)

  const { enableCategories, enableRoleGroups, enableExternalReports } =
    courseConfig

  const isRouteMatching = (route) => {
    return props.location.pathname.includes(route)
  }

  const shouldRenderGroup = (routes) => {
    return routes.some(isRouteMatching)
  }

  return (
    <Container className='mt--6 ' fluid>
      <Card
        className='py-3 col'
        style={{ minHeight: '77vh', padding: '20px; 10px' }}
      >
        <div className='col-12'>
          <div className='settings-tabs dFlex md-flexCol gap06'>
            {shouldRenderGroup([
              '/settings/groups',
              '/settings/locations',
              '/settings/location-groups',
              '/settings/org-groups',
            ]) && (
              <>
                {/* LOCATION SETTINGS */}
                {[1, 2, 4, 5].includes(user.access) && (
                  <NavLink
                    className='textCenter hoverLinkItems'
                    activeClassName='current'
                    to='/settings/groups'
                  >
                    {language.settings?.group_management}
                  </NavLink>
                )}
                {[1].includes(user.access) && (
                  <NavLink
                    className='textCenter'
                    activeClassName='current'
                    to='/settings/locations'
                  >
                    {language.settings?.locations}
                  </NavLink>
                )}
                {[1].includes(user.access) && (
                  <NavLink
                    className='textCenter'
                    activeClassName='current'
                    to='/settings/location-groups'
                  >
                    {language.settings?.location_groups}
                  </NavLink>
                )}

                {[1].includes(user.access) && enableCategories === 1 && (
                  <NavLink
                    className='textCenter'
                    activeClassName='current'
                    to='/settings/org-groups'
                  >
                    {language.settings?.org_groups}
                  </NavLink>
                )}
                {/* LOCATION SETTINGS */}
              </>
            )}

            {shouldRenderGroup([
              '/settings/users',
              '/settings/role-groups',
              '/settings/roles',
              '/settings/rewards',
            ]) && (
              <>
                {/* USERS SETTINGS */}
                {[1, 2, 4, 5].includes(user.access) && (
                  <NavLink
                    className='col3 lg-col12 itemsCenter textCenter'
                    activeClassName='current'
                    to='/settings/users'
                  >
                    {language.settings?.user_management}
                  </NavLink>
                )}
                {[1].includes(user.access) && (
                  <NavLink
                    className='col3 lg-col12 itemsCenter textCenter'
                    activeClassName='current'
                    to='/settings/roles'
                  >
                    {language.settings?.roles}
                  </NavLink>
                )}
                {[1].includes(user.access) && enableRoleGroups === 1 && (
                  <NavLink
                    className='col3 lg-col12 itemsCenter textCenter'
                    activeClassName='current'
                    to='/settings/role-groups'
                  >
                    Role Groups
                  </NavLink>
                )}
                {[1].includes(user.access) && (
                  <NavLink
                    className='col3 lg-col12 itemsCenter textCenter'
                    activeClassName='current'
                    to='/settings/rewards'
                  >
                    {language.settings?.reward_management}
                  </NavLink>
                )}
                {/* USERS SETTINGS */}
              </>
            )}

            {shouldRenderGroup([
              '/settings/question-bank',
              '/settings/external-reports',
              '/settings/help',
            ]) && (
              <>
                {/* OTHER SETTINGS */}
                {[1, 2, 4, 5].includes(user.access) && (
                  <NavLink
                    className='col4 lg-col12 itemsCenter textCenter'
                    activeClassName='current'
                    to='/settings/question-bank'
                  >
                    Question Bank
                  </NavLink>
                )}
                {[1].includes(user.access) && enableExternalReports === 1 && (
                  <NavLink
                    className='col4 lg-col12 itemsCenter textCenter'
                    activeClassName='current'
                    to='/settings/external-reports'
                  >
                    External Reports
                  </NavLink>
                )}
                <NavLink
                  className='col4 lg-col12 itemsCenter textCenter'
                  activeClassName='current'
                  to='/settings/help'
                >
                  Help
                </NavLink>
                {/* OTHER SETTINGS */}
              </>
            )}
          </div>

          <Suspense
            fallback={
              <div className='col-12 d-flex justify-content-center mt-5'>
                <Loader />
              </div>
            }
          >
            {props.location.pathname === '/settings' &&
              user.access &&
              ([3].includes(user.access) ? (
                <Redirect from='/settings' to='/dashboard' />
              ) : (
                <Redirect from='/settings' to='/settings/groups' />
              ))}

            {props.location.pathname === '/config' &&
              user.access &&
              [1].includes(user.access) && (
                <Redirect from='/config' to='/config/general' />
              )}
            {[1, 2, 4, 5].includes(user.access) ? (
              <Route
                exact
                path='/settings/users'
                render={(props) => <UserList {...props} />}
              />
            ) : null}
            {[1, 2, 4, 5].includes(user.access) &&
            props.location.pathname.indexOf('import') === -1 ? (
              <Route
                exact
                path='/settings/users/:id'
                render={(props) => <UserForm {...props} />}
              />
            ) : (
              <Route
                exact
                path='/settings/users/import'
                render={(props) => <ImportUser {...props} />}
              />
            )}

            {user.access !== 3 ? (
              <div>
                {[1].includes(user.access) ? (
                  <Route
                    exact
                    path='/settings/external-reports'
                    render={(props) => (
                      <ExternalReports {...props} language={language} />
                    )}
                  />
                ) : null}
                {[1].includes(user.access) ? (
                  <Route
                    exact
                    path='/settings/locations'
                    render={(props) => (
                      <Stores {...props} language={language} />
                    )}
                  />
                ) : null}

                {[1].includes(user.access) ? (
                  <Route
                    exact
                    path='/settings/role-groups'
                    render={(props) => (
                      <RoleGroup
                        {...props}
                        groups={groups}
                        language={language}
                        roleGroups={roleGroups}
                        user={user}
                        roles={roles}
                      />
                    )}
                  />
                ) : null}

                {[1, 2, 4, 5].includes(user.access) ? (
                  <Route
                    exact
                    path='/settings/role-groups/:id'
                    render={(props) => (
                      <RoleGroup
                        {...props}
                        language={language}
                        groups={groups}
                        roleGroups={roleGroups}
                        user={user}
                        roles={roles}
                      />
                    )}
                  />
                ) : null}

                {[1, 2, 4, 5].includes(user.access) ? (
                  <Route
                    exact
                    path='/settings/role-groups/roles/:id/import'
                    render={(props) => (
                      <RoleGroup {...props} language={language} />
                    )}
                  />
                ) : null}
                {[1, 2, 4, 5].includes(user.access) ? (
                  <Route
                    exact
                    path='/settings/role-groups/multiple-import'
                    render={(props) => (
                      <RoleGroup {...props} language={language} />
                    )}
                  />
                ) : null}

                {[1].includes(user.access) ? (
                  <Route
                    exact
                    path='/settings/location-groups'
                    render={(props) => (
                      <Location
                        {...props}
                        language={language}
                        groups={groups}
                        user={user}
                      />
                    )}
                  />
                ) : null}
                {[1, 2, 4, 5].includes(user.access) ? (
                  <Route
                    exact
                    path='/settings/location-groups/locations/:id'
                    render={(props) => (
                      <Location
                        {...props}
                        language={language}
                        groups={groups}
                        user={user}
                      />
                    )}
                  />
                ) : null}
                {[1, 2, 4, 5].includes(user.access) ? (
                  <Route
                    exact
                    path='/settings/location-groups/location/new'
                    render={(props) => (
                      <Location
                        {...props}
                        language={language}
                        groups={groups}
                        user={user}
                      />
                    )}
                  />
                ) : null}
                {[1, 2, 4, 5].includes(user.access) ? (
                  <Route
                    exact
                    path='/settings/location-groups/locations/:id/import'
                    render={(props) => (
                      <Location
                        {...props}
                        language={language}
                        groups={groups}
                        user={user}
                      />
                    )}
                  />
                ) : null}
                {[1, 2, 4, 5].includes(user.access) ? (
                  <Route
                    exact
                    path='/settings/location-groups/multiple-import'
                    render={(props) => (
                      <Location
                        {...props}
                        language={language}
                        groups={groups}
                        user={user}
                      />
                    )}
                  />
                ) : null}
                {[1].includes(user.access) && enableCategories === 1 ? (
                  <Route
                    exact
                    path='/settings/org-groups'
                    render={(props) => (
                      <OrgGroup
                        {...props}
                        language={language}
                        user={user}
                        groups={groups}
                      />
                    )}
                  />
                ) : null}
                {[1].includes(user.access) && enableCategories === 1 ? (
                  <Route
                    exact
                    path='/settings/org-groups/new'
                    render={(props) => (
                      <OrgGroup
                        {...props}
                        language={language}
                        user={user}
                        groups={groups}
                      />
                    )}
                  />
                ) : null}
                {[1].includes(user.access) &&
                !window.location.pathname.includes('new') &&
                enableCategories === 1 ? (
                  <Route
                    exact
                    path='/settings/org-groups/:id'
                    render={(props) => (
                      <OrgGroup
                        {...props}
                        language={language}
                        user={user}
                        groups={groups}
                      />
                    )}
                  />
                ) : null}

                {[1].includes(user.access) ? (
                  <Route
                    exact
                    path='/settings/roles'
                    render={(props) => <Role {...props} language={language} />}
                  />
                ) : null}

                {[1, 2, 4, 5].includes(user.access) ? (
                  <Route
                    exact
                    path='/settings/groups/courses-completion/import'
                    render={(props) => <SettingsGroup {...props} />}
                  />
                ) : null}
                {[1, 2, 4, 5].includes(user.access) ? (
                  <Route
                    exact
                    path='/settings/groups/groups-completion/import'
                    render={(props) => <SettingsGroup {...props} />}
                  />
                ) : null}

                {[1].includes(user.access) ? (
                  <Route
                    exact
                    path='/settings/rewards'
                    render={(props) => (
                      <Rewards {...props} language={language} />
                    )}
                  />
                ) : null}

                {[1, 2, 4, 5].includes(user.access) ? (
                  <Switch>
                    <Route
                      exact
                      path='/settings/groups'
                      render={(props) => <SettingsGroup {...props} />}
                    />
                    <Route
                      exact
                      path='/settings/groups/courses/:id'
                      render={(props) => <SettingsGroup {...props} />}
                    />
                  </Switch>
                ) : null}

                {[1, 2, 4, 5].includes(user.access) ? (
                  <Route
                    exact
                    path='/settings/question-bank'
                    render={(props) => (
                      <QuestionBank {...props} language={language} />
                    )}
                  />
                ) : null}
              </div>
            ) : null}
            <Route
              exact
              path='/settings/help'
              render={(props) => (
                <Help {...props} user={user} language={language} />
              )}
            />
          </Suspense>
        </div>
      </Card>
    </Container>
  )
}

export default SettingsContainer
